import * as client_hooks from '../../../src/hooks.client.ts';


export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20')
];

export const server_loads = [];

export const dictionary = {
		"/(noauth)": [17,[3]],
		"/(auth)/checklist": [4,[2]],
		"/(auth)/dashboard": [5,[2]],
		"/(auth)/forms": [6,[2]],
		"/(auth)/forms/inbox": [8,[2]],
		"/(auth)/forms/inbox/[dispatchId]": [9,[2]],
		"/(auth)/forms/submissions/[submissionId]": [10,[2]],
		"/(auth)/forms/[formId]": [7,[2]],
		"/(auth)/jobs": [11,[2]],
		"/(auth)/notifications": [12,[2]],
		"/(noauth)/password/forgot": [18,[3]],
		"/(noauth)/password/reset": [19,[3]],
		"/(noauth)/password/sent": [20,[3]],
		"/(auth)/schedule": [13,[2]],
		"/(auth)/schedule/[jobId]": [14,[2]],
		"/(auth)/settings": [15,[2]],
		"/(auth)/time": [16,[2]]
	};

export const hooks = {
	handleError: client_hooks.handleError || (({ error }) => { console.error(error) }),
	init: client_hooks.init,
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';